import { useAsyncDataRequestStatus } from '@/wabunka-src/common/composables';
import { useMicroCMSGetListDetail } from '@/wabunka-src/common/composables/query/useMicroCMSClient';
import type { microCMSDraftKeyQuery } from '@/wabunka-src/common/models/microCMS';
import type { DestinationContentResponse, DestinationContentViewModel } from '@/wabunka-src/features/Destination/models/destinationContent';
import { createDefaultDestinationContent } from '@/wabunka-src/features/Destination/models/destinationContent';

import type { AsyncDataRequestStatus } from 'nuxt/app';

/**
 * pathとqueryからdedupe用のkeyの組み立てを行う
 */
const buildKey = (path: string, query?: object, server?: boolean) => {
  const sortedQuery = query ? JSON.stringify(query, Object.keys(query).sort()) : '';
  return path + (sortedQuery ? ',query=' + sortedQuery : '') + (server ? ',server' : ',client');
};

interface UseDestinationContentQueryParams {
  destination: string;
  draftKey?: microCMSDraftKeyQuery;
  server?: boolean;
}

/**
 * destination content の取得に使用する Composable
 * Page でのみ使用可能
 */
export const useDestinationContentQuery = async ({ destination, draftKey, server = false }: UseDestinationContentQueryParams) => {
  const contentId = destination;
  const filters = 'type[equals]destination';

  const { data, status }: { data: Ref<DestinationContentResponse | null>; status: Ref<AsyncDataRequestStatus> } = await useMicroCMSGetListDetail<DestinationContentResponse>(
    {
      endpoint: 'en-featured',
      contentId,
      queries: { ...draftKey, filters },
    },
    {
      key: buildKey(`en-featured-${contentId}`, { ...draftKey }, server),
      server: server,
    },
  );

  const destinationContent = computed<DestinationContentViewModel>(() => data.value || createDefaultDestinationContent());

  return { destinationContent, ...useAsyncDataRequestStatus(status) };
};
